import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tour-wrapper" }
const _hoisted_2 = { class: "tour-button-container" }
const _hoisted_3 = { class: "tour-button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_QuickStart = _resolveComponent("QuickStart")!
  const _component_HomePage = _resolveComponent("HomePage")!
  const _component_TranslationConfig = _resolveComponent("TranslationConfig")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_AddTranslation = _resolveComponent("AddTranslation")!
  const _component_LoadTranslation = _resolveComponent("LoadTranslation")!
  const _component_UpdateTranslation = _resolveComponent("UpdateTranslation")!
  const _component_SegmentControls = _resolveComponent("SegmentControls")!
  const _component_DocumentActions = _resolveComponent("DocumentActions")!
  const _component_MergeSegments = _resolveComponent("MergeSegments")!
  const _component_SplitSegments = _resolveComponent("SplitSegments")!
  const _component_TextStyles = _resolveComponent("TextStyles")!
  const _component_TermRecognition = _resolveComponent("TermRecognition")!
  const _component_ExternalTranslation = _resolveComponent("ExternalTranslation")!
  const _component_DocumentSearch = _resolveComponent("DocumentSearch")!
  const _component_ConcordanceSearch = _resolveComponent("ConcordanceSearch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_text, { type: "info" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('helpInfo.homePageTours')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_QuickStart, { "tour-available": _ctx.homePage }, null, 8, ["tour-available"]),
      _createVNode(_component_HomePage, { "tour-available": _ctx.homePage }, null, 8, ["tour-available"]),
      _createVNode(_component_TranslationConfig, { "tour-available": _ctx.homePage }, null, 8, ["tour-available"])
    ]),
    _createVNode(_component_el_divider),
    _createVNode(_component_el_text, { type: "info" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('helpInfo.documentPageTours')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_AddTranslation, { "tour-available": _ctx.documentPage }, null, 8, ["tour-available"]),
      _createVNode(_component_LoadTranslation, { "tour-available": _ctx.documentPage }, null, 8, ["tour-available"]),
      _createVNode(_component_UpdateTranslation, { "tour-available": _ctx.documentPage }, null, 8, ["tour-available"]),
      _createVNode(_component_SegmentControls, { "tour-available": _ctx.documentPage }, null, 8, ["tour-available"]),
      _createVNode(_component_DocumentActions, { "tour-available": _ctx.documentPage }, null, 8, ["tour-available"]),
      _createVNode(_component_MergeSegments, { "tour-available": _ctx.documentPage }, null, 8, ["tour-available"]),
      _createVNode(_component_SplitSegments, { "tour-available": _ctx.documentPage }, null, 8, ["tour-available"]),
      _createVNode(_component_TextStyles, { "tour-available": _ctx.documentPage }, null, 8, ["tour-available"]),
      _createVNode(_component_TermRecognition, { "tour-available": _ctx.documentPage }, null, 8, ["tour-available"]),
      _createVNode(_component_ExternalTranslation, { "tour-available": _ctx.documentPage }, null, 8, ["tour-available"]),
      _createVNode(_component_DocumentSearch, { "tour-available": _ctx.documentPage }, null, 8, ["tour-available"]),
      _createVNode(_component_ConcordanceSearch, { "tour-available": _ctx.documentPage }, null, 8, ["tour-available"])
    ])
  ]))
}